import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Campania } from '../../../_models/campania';
import { CampaniaDescuentoDestino } from '../../../_models/campania-descuento-destino';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { CampaniaDescuentoDestinoService } from '../../../_services/campania-descuento-destino.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-campania-descuento-destino-detalle',
  templateUrl: 'campania-descuento-destino-detalle.component.html'
} )

export class CampaniaDescuentoDestinoDetalleComponent implements OnInit {

  @Input() campania: Campania;
  formulario: FormGroup;

  /** Listas */
  lisCampaniasDescuento: CampaniaDescuentoDestino[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCampaniaDescuento: CampaniaDescuentoDestinoService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private location: Location
  ) {
  }

  ngOnInit() {
    if ( this.campania && (this.campania.idCampania !== '' && this.campania.idCampania !== null && this.campania.idCampania !== undefined) ) {
      /** Se carga las campanias */
      this.serCampaniaDescuento.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
        this.lisCampaniasDescuento = registros.filter( x => x.indicadorHabilitado );
        const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/campania' );
        if ( mn ) {
          this.menu = mn;
        }

        this.columnas = [
          { field: 'nombreDestino', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESTINO' ), sort: true },
          { field: 'descuentoTasa', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' ), sort: true }
        ];

        this.carTabla = false;
        this.carInformacionInicial = false;
      } );
    }
  }

  regresar() {
    this.location.back();
  }

}
